import { ReactComponent as OutlineCross16 } from "assets/svg/outline-cross-16-2.svg";
import { ReactComponent as OutlinePlus16 } from "assets/svg/outline-plus-16.svg";
import { ReactComponent as OutlineRefresh16 } from "assets/svg/outline-refresh-16.svg";
import numberToOrdinal from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/session-repeat-rule-editor/utils/numberToOrdinal";
import IconButton from "components/icon-button";
import moment from "moment-timezone";
import { useState } from "react";
import formatList from "utils/formatList";
import shortToLongWeekday from "../../../../../../../../../../../../../utils/shortToLongWeekday";
import { useCalendarTime } from "../../../../../../../../contexts/CalendarTimeContext";
import styles from "./RecurringTag.module.scss";

type Props = {
  repeatRule: RepeatRule;
};

const getRepeatFrequencyText = (repeatRule: RepeatRule) => {
  const segments = ["Every"];

  const skip = repeatRule.repeat_every;
  if (skip > 1) {
    segments.push(skip.toString());
  }

  const weekMonthOrYear = repeatRule.repeat_interval;
  if (skip > 1) {
    segments.push(`${weekMonthOrYear}s`);
  } else {
    segments.push(weekMonthOrYear);
  }

  if (weekMonthOrYear === "week") {
    segments.push("on");
    segments.push(
      formatList(repeatRule.repeat_on_days.map(shortToLongWeekday)),
    );
  } else if (
    weekMonthOrYear === "month" &&
    repeatRule.repeat_on_nth_day_of_week_in_month
  ) {
    segments.push("on the");

    const nthOrLast = repeatRule.repeat_on_nth_day_of_week_in_month.nth;
    segments.push(nthOrLast === -1 ? "last" : numberToOrdinal(nthOrLast));
    segments.push(
      shortToLongWeekday(
        repeatRule.repeat_on_nth_day_of_week_in_month.day_of_week,
      ),
    );
  }

  return segments.join(" ");
};

const getEndText = (repeatRule: RepeatRule, timezone: string) => {
  switch (repeatRule.repeat_end.type) {
    case "end_after":
      return `Ends after ${repeatRule.repeat_end.end_after} sessions`;
    case "end_date":
      return `Ends on ${moment
        .tz(repeatRule.repeat_end.end_date, timezone)
        .format("MMMM Do YYYY")}`;
    default:
      return "";
  }
};

const RecurringTag = ({ repeatRule }: Props) => {
  const { currentCalendarTimezone } = useCalendarTime();
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={styles["tag"]}>
        <div className={styles["tag__left"]}>
          <OutlineRefresh16 className={"mr-2"} />
          Recurring sessions
        </div>
        <div className={styles["tag__right"]}>
          <IconButton onClick={() => setOpen((prev) => !prev)}>
            {open ? <OutlineCross16 /> : <OutlinePlus16 />}
          </IconButton>
        </div>
      </div>

      {open && (
        <div className={styles["content"]}>
          <div className={styles["content__row"]}>
            <div className={styles["content__row__label"]}>Recur:</div>
            <div>
              {getRepeatFrequencyText(repeatRule)}
              <br />
              {getEndText(repeatRule, currentCalendarTimezone)}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RecurringTag;
